import { useLocation } from 'react-router';
import { useMemoOne } from 'use-memo-one';

export function useSearchParams() {
  const { search } = useLocation();
  return useMemoOne(() => new URLSearchParams(search), [search]);
}
